import React from 'react'
import PropTypes from 'prop-types'
import { Image, Copy, Box, Flex, HorizontalRule, Hide } from '@elparking/components'

import OverflowBlox from 'commons/js/ui/OverflowBlox'
import CharginPointMainInfo from './CharginPointMainInfo'

import { MultilineBlock } from 'commons/js/ui/MultilineBlock'
import { FormattedMessage } from 'react-intl'
import Timetable from 'commons/js/components/Timetable'
import PlugIcon from 'commons/js/components/PlugIcon'
import PlugName, { getPlugName } from '../PlugName'
import BannerDownloadApp from '../BannerDownloadApp'

import styled from 'styled-components'
import { SrollContainer } from '../../ui/ChargingPointDetailContainer'
import Rates from '../Rates'

import ChargingPointSpeedRounded from './ChargingPointSpeedRounded'

ChargingPointDetail.propTypes = {
    chargingPoint: PropTypes.shape({
        name: PropTypes.string,
        address: PropTypes.string,
        description: PropTypes.string,
        timetables: PropTypes.object,
        plugs: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            slug: PropTypes.string,
            speedChargingType: PropTypes.number,
        })),
        medias: PropTypes.object,
        pricePerPlug: PropTypes.object,
        priceEnergy: PropTypes.object,
        priceTime: PropTypes.object,
        latitude: PropTypes.number,
        longitude: PropTypes.number,
        power: PropTypes.number,
    }),
    computeDistanceTo: PropTypes.func,
    onClose: PropTypes.func,
}

ChargingPointDetail.defaultProps = {
    onClose: () => {},
    computeDistanceTo: () => {},
    chargingPoint: null,
}

const ArrowIconClose = styled(Image)`
    position: absolute;
    cursor: pointer;
    left: 92%;
`

const CrossIconClose = styled.img`
    position: absolute;
    cursor: pointer;
    left: 85%;
    top: 0;
`

const RelativeContainer = styled.div`
    position: relative;
    height: 100%;
`

const ChargingPointImage = styled(Image)`
    display: block;
    max-width: 100%;
    height: 200px;
    width: 100%;
    object-fit: cover;
    object-position: center;
`

function ChargingPointDetail ({chargingPoint, computeDistanceTo, onClose}) {
    return (
        <>
            {
                chargingPoint
                ? <RelativeContainer>
                    <Hide lg>
                        <CrossIconClose src='/images/electric-charge/cross_close_detail.svg' onClick={() => onClose(null)}/>
                    </Hide>
                    <Hide xs sm md>
                        {chargingPoint && <ArrowIconClose alt='x' src='/images/electric-charge/arrow_close_detail.svg' onClick={() => onClose(null)}/>}
                    </Hide>
                    <SrollContainer>
                        {
                                chargingPoint.medias && chargingPoint.medias.urlRegularSize
                                ? <ChargingPointImage alt={chargingPoint.name} src={chargingPoint.medias.urlRegularSize} />
                                : <ChargingPointImage alt={chargingPoint.name} src='/images/electric-charge/placeholder_charging_point.svg' />
                            }
                        <Hide lg>
                            <BannerDownloadApp text={<FormattedMessage defaultMessage='Reserva este punto de carga descargándote la app' />} />
                        </Hide>
                        <Box p='16px'>
                            <Hide md lg>
                                <Box pb='32px'>
                                    <CharginPointMainInfo
                                      name={chargingPoint.name}
                                      address={chargingPoint.address}
                                      plugs={chargingPoint.plugs}
                                      distance={computeDistanceTo(
                                            chargingPoint.latitude,
                                            chargingPoint.longitude)
                                      }
                                      power={chargingPoint.power}
                                    />
                                </Box>
                            </Hide>
                            <Hide xs sm>
                                <Copy color='gray60' size='xxxSmall' transform='uppercase' padding='0 0 16px 0'>
                                    <FormattedMessage
                                      defaultMessage='Punto de carga'
                                    />
                                </Copy>
                                <Box>
                                    <ChargingPointSpeedRounded plugs={chargingPoint.plugs}/>
                                    <Copy as='span' padding='0' fontSize='xxSmall' fontWeight='medium'>{chargingPoint.name}</Copy>
                                    <Copy as='span' padding='0'>{' · '}</Copy>
                                    <Copy as='span' padding='0' fontSize='xxSmall' fontWeight='regular'>{chargingPoint.address}</Copy>
                                </Box>
                                <HorizontalRule />
                            </Hide>
                            <Box pb='16px'>
                                <Copy color='gray' size='xxSmall' transform='uppercase' padding='0 0 8px 0'>
                                    <FormattedMessage
                                      defaultMessage='Conectores'
                                    />
                                </Copy>
                                <Flex flexWrap='wrap'>
                                    {
                                        chargingPoint.plugs.map((plug) => (
                                            <Flex flexDirection='column' alignItems='center' key={plug.id} w='25%' mb='16px'>
                                                <PlugIcon plugName={getPlugName(plug.slug)} plugSlug={plug.slug} size='xxLarge' />
                                                <PlugName p='0' color='main' fontSize='xxSmall' fontWeight='medium' plugSlug={plug.slug} />
                                            </Flex>
                                        ))
                                    }
                                </Flex>
                            </Box>
                            <Box pb='32px'>
                                <Copy color='gray' size='xxSmall' transform='uppercase' padding='0 0 8px 0'>
                                    <FormattedMessage
                                      defaultMessage='Tarifas repostaje'
                                />
                                </Copy>
                                <Rates
                                  conection={chargingPoint.pricePerPlug}
                                  power={chargingPoint.priceEnergy}
                                  time={chargingPoint.priceTime}
                            />
                            </Box>
                            <Box pb='32px'>
                                <Copy color='gray' size='xxSmall' transform='uppercase' padding='0 0 8px 0'>
                                    <FormattedMessage
                                      defaultMessage='Información'
                            />
                                </Copy>
                                <Box mb='0.5em'>
                                    <OverflowBlox
                                      active={chargingPoint.description.length >= 200}
                                      height='56px'
                            >
                                        <Copy color='gray' fontWeight='regular' size='xSmall' padding='0'>
                                            <MultilineBlock text={chargingPoint.description} />
                                        </Copy>
                                    </OverflowBlox>
                                </Box>
                            </Box>
                            {
                        chargingPoint.timetables &&
                        <Box>
                            <Copy color='gray' size='xxSmall' transform='uppercase' padding='0 0 8px 0'>
                                <FormattedMessage
                                  defaultMessage='Horario del punto de carga'
                            />
                            </Copy>
                            <Timetable timetables={chargingPoint.timetables} />
                        </Box>
                    }
                        </Box>
                    </SrollContainer>
                </RelativeContainer>
                : <Box h='100%' w='100%' />
            }
        </>
    )
}

export default ChargingPointDetail
